module.exports = __webpack_public_path__ + "static/media/hospitable-viking-blue.8e31d03d.png";